import { Color, LineBasicMaterial, LineBasicMaterialParameters } from '../../thirdparty/three/imports';
import { Material3D } from './Material3D';

export interface LineBasicMaterial3D
{
    get _material(): LineBasicMaterial;
    set _material(v: LineBasicMaterial);
}

export class LineBasicMaterial3D extends Material3D
{
    get color(): Color
    {
        return this._material.color;
    }
    set color(v)
    {
        this._material.color = v;
    }

    constructor(parameters?: LineBasicMaterialParameters)
    {
        super();
        this._material = new LineBasicMaterial(parameters);
    }
}
